import React from 'react';
import { useTheme } from '@material-ui/core';
import Tour from 'reactour';

// import _set from 'lodash/set';

// const useStyles = (params = {}) => {
//     return makeStyles(theme => ({
//         root: {}
//     }));
// };

const AfitdTour = props => {
    const { isHidden, steps, open, onClose, ...otherProps } = props;
    const theme = useTheme();

    // const theme = useTheme();
    // const classes = useStyles(theme);

    return isHidden ? null : (
        <Tour
            steps={steps}
            isOpen={open}
            onRequestClose={onClose}
            showCloseButton={false}
            badgeContent={(curr, tot) => `${curr} of ${tot}`}
            // lastStepNextButton={<div>Okay</div>}
            closeWithMask={false}
            disableDotsNavigation={true}
            disableInteraction={true}
            accentColor={theme.palette.primary.main}
            rounded={20}
            {...otherProps}
        />
    );
};

export default AfitdTour;
